import { normalizeSsoProviders } from "./idp/normalizeSsoProvider";

/** @typedef {'sso' | 'password'} AuthenticationMode */

/**
 * @param {object | null | undefined} resolved
 * @returns {AuthenticationMode}
 */
export function resolveInitialAuthMode(resolved) {
  const providers = normalizeSsoProviders(resolved?.providers);
  const hasSso = Boolean(resolved?.ssoSignInEnabled && providers.length);

  if (hasSso) {
    return "sso";
  }

  if (resolved?.passwordSignInEnabled ?? true) {
    return "password";
  }

  return "sso";
}

/**
 * @param {object} input
 * @param {boolean} input.discoveryComplete
 * @param {boolean} input.showSso
 * @param {AuthenticationMode} input.authenticationMode
 * @returns {boolean}
 */
export function shouldShowSsoPanel({
  discoveryComplete,
  showSso,
  authenticationMode,
}) {
  return Boolean(discoveryComplete && showSso && authenticationMode === "sso");
}

/**
 * @param {object} input
 * @param {boolean} input.discoveryComplete
 * @param {AuthenticationMode} input.authenticationMode
 * @param {boolean} input.showPasswordEnabled
 * @param {boolean} input.hidePasswordEnforced
 * @returns {boolean}
 */
export function shouldShowPasswordPanel({
  discoveryComplete,
  authenticationMode,
  showPasswordEnabled,
  hidePasswordEnforced,
}) {
  return Boolean(
    discoveryComplete &&
      authenticationMode === "password" &&
      showPasswordEnabled &&
      !hidePasswordEnforced
  );
}
